// Đọc/ghi một query param trên thanh địa chỉ (replaceState: không thêm lịch sử, giữ nguyên các param khác như version)
export const getUrlParam = (key) => {
    try {
        return new URLSearchParams(window.location.search).get(key)
    } catch (e) {
        return null
    }
}

export const setUrlParam = (key, value) => {
    try {
        const params = new URLSearchParams(window.location.search)
        params.set(key, value)
        window.history.replaceState(window.history.state, '', `${window.location.pathname}?${params.toString()}${window.location.hash}`)
    } catch (e) {
        // Không ghi được URL thì bỏ qua, trạng thái vẫn nằm trong state
    }
}
